import { liveSync } from "@/fireinit.js";
import Vue from "vue";
import axios from "axios";

export default {
  // Leads
  loadLeadsForBusiness: async ({ commit, rootState, state }, payload) => {
    let data = await axios.get(
      `${rootState.axios.API}entityLink/viaBusinessLinkKey`,
      {
        params: {
          businessLinkKey: payload,
        },
      }
    );
    commit("setLastSyncBusinessLeads", new Date().getTime());
    commit("setBusinessLeadsList", data.data);
  },
  saveAllLeads: async ({ commit, rootState }, payload) => {
    Vue.notify({
      type: "success",
      duration: 2000,
      title: "Successfully Saved",
    });
    await axios.post(
      `${rootState.axios.API}entityLink/saveAll/viaBusinessLinkKey`,
      payload
    );
    let timeStamp = new Date().getTime();
    commit("setLastSyncBusinessLeads", timeStamp);
    liveSync.doc(payload.linkKey).set({
      timeStamp: timeStamp,
    });
  },
  // Prospecting Buyers
  loadProspectingBuyersForBusiness: async ({ commit, rootState }, payload) => {
    let data = await axios.get(
      `${rootState.axios.API}entityLink/prospectingBuyers`,
      {
        params: {
          goodCauseLinkKey: payload,
        },
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
    commit("setLastSyncProspectingBuyers", new Date().getTime());
    commit("setProspectingBuyers", data.data);
  },
  saveAllProspectingBuyers: async ({ commit, rootState }, payload) => {
    Vue.notify({
      type: "success",
      duration: 2000,
      title: "Successfully Saved",
    });
    await axios.post(
      `${rootState.axios.API}entityLink/saveAll/prospectingBuyers`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
    let timeStamp = new Date().getTime();
    commit("setLastSyncProspectingBuyers", timeStamp);
    liveSync.doc(payload.linkKey).set({
      timeStamp: timeStamp,
    });
  },
};
